import { withViewModel } from '@hooks/useViewModel';
import CheckboxAutocomplete from './CheckboxAutocomplete';
import useCheckboxAutocomplete from './useCheckboxAutocomplete';

const CheckboxAutocompleteContainer = withViewModel(CheckboxAutocomplete, useCheckboxAutocomplete);

export default CheckboxAutocompleteContainer;
